import BaseService from '@root/core/class/BaseService';

class forgotPassService extends BaseService {
  public postReset = (body: Record<string, any>) => {
    return this.post('/warehouse/reset-password', body);
  };
  public getResetToken = (resetToken: any) => {
    return this.get(`/warehouse/reset-password/${resetToken}`);
  };
  public changePass = (value: any, body: Record<string, any>) => {
    return this.put(`/warehouse/reset-password/${value}`, body);
  };

  public changePassForwarder = (value: any, body: Record<string, any>) => {
    return this.put(`/forwarding/reset-password/${value}`, body);
  };

  ////seller
  public postResetSell = (body: Record<string, any>) => {
    return this.post(`/seller/reset-password`, body);
  };

  ////forwarder
  public postResetForwarder = (body: Record<string, any>) => {
    return this.post(`/forwarding/reset-password`, body);
  };
}
export default new forgotPassService('/api/v1', true);
